import { render, staticRenderFns } from "./ghacAwards.vue?vue&type=template&id=48ddddc0&scoped=true&"
import script from "./ghacAwards.vue?vue&type=script&lang=js&"
export * from "./ghacAwards.vue?vue&type=script&lang=js&"
import style0 from "./ghacAwards.vue?vue&type=style&index=0&id=48ddddc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddddc0",
  null
  
)

export default component.exports